import React, { useRef, useEffect } from "react";
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";
import ReactMarkdown from "react-markdown";

const Accordion = ({ id, title, content }) => {
  const accordionRef = useRef();
  const currentSlug = window.location.href.split("#")[1] ?? "";

  useEffect(() => {
    if (currentSlug.includes(id)) {
      setTimeout(() => {
        accordionRef.current.scrollIntoView({ behavior: "smooth" });
      }, 0);
    }
  }, []);

  return (
    <Disclosure
      as="div"
      className="w-full py-6"
      defaultOpen={currentSlug.includes(id)}
      ref={accordionRef}
    >
      {({ open }) => (
        <>
          <DisclosureButton className="w-full flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={3}
              stroke="currentColor"
              className={`flex-shrink-0 size-5 text-primary ${
                open && "rotate-180"
              }`}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m19.5 8.25-7.5 7.5-7.5-7.5"
              />
            </svg>

            <span className="text-primary font-bold text-left">{title}</span>
          </DisclosureButton>
          <div className="overflow-hidden">
            <DisclosurePanel
              transition
              className="origin-top transition duration-200 ease-out data-[closed]:-translate-y-6 data-[closed]:opacity-0 py-6"
            >
              <ReactMarkdown className="markdown">{content}</ReactMarkdown>
            </DisclosurePanel>
          </div>
        </>
      )}
    </Disclosure>
  );
};

const AccordionGroup = ({ children }) => {
  return <div className="divide-y divide-[#afb6b9]">{children}</div>;
};

export { Accordion, AccordionGroup };
